import { render, staticRenderFns } from "./kato.vue?vue&type=template&id=0a340b2c&"
import script from "./kato.vue?vue&type=script&lang=js&"
export * from "./kato.vue?vue&type=script&lang=js&"
import style0 from "./kato.vue?vue&type=style&index=0&id=0a340b2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports